// Sentry bundler plugin (vite.config.ts) と実行時コード (sentry_helper.ts) の双方から
// 参照するための定数。thirdPartyErrorFilterIntegration の filterKeys と
// applicationKey を一致させるために共有する。
export const SENTRY_APPLICATION_KEY = 'yakukyari-agent-frontend';
